import Config from "../../../Auth/config";

export const timeOut = async ({ fun, timeout = Config.messagePopTime }) => {
  return setTimeout(fun, timeout);
};
